package com.exura.components.qr

import androidx.compose.runtime.*
import com.exura.ui.Dimens
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.CSSLengthOrPercentageValue
import org.jetbrains.compose.web.dom.Img

@Composable
fun QRCodeImage(
    data: String,
    size: CSSLengthOrPercentageValue = Dimens.qrImageSizeUI,
    foregroundColor: String = "000000", // hex without #
    backgroundColor: String = "ffffff", // hex without #
    modifier: Modifier = Modifier
) {
    val qrUrl = remember(data, size, foregroundColor, backgroundColor) {
        val encodedData = urlEncode(data)
        "https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodedData}&color=${foregroundColor}&bgcolor=${backgroundColor}"
    }

    Img(
        src = qrUrl,
        alt = "QR Code for: $data",
        attrs = modifier
            .size(size)
            .toAttrs()
    )
}
fun urlEncode(input: String): String = input
    .replace("%", "%25")  // Must be first
    .replace(" ", "%20")
    .replace("&", "%26")
    .replace("=", "%3D")
    .replace("?", "%3F")
    .replace("#", "%23")
    .replace("/", "%2F")
    .replace(":", "%3A")

